/**
 * Clinical Notes API
 * Doctor clinical notes CRUD operations
 */

import { apiClient } from '../api-client';

export interface ClinicalNote {
  id: number;
  patient_id: number;
  doctor_id: number;
  doctor_name: string;
  notes: string;
  airway_complications?: string | null;  // ✅ NEW
  rejection_events?: string | null;      // ✅ NEW
  created_at: string;
  created_by: number;
  updated_at?: string | null;
  updated_by?: number | null;
}

export interface ClinicalNotesResponse {
  notes: ClinicalNote[];
}

export interface CreateClinicalNoteRequest {
  patient_id: number;
  notes: string;
  airway_complications?: string | null;  // ✅ NEW
  rejection_events?: string | null;      // ✅ NEW
}

export interface UpdateClinicalNoteRequest {
  notes: string;
  airway_complications?: string | null;  // ✅ NEW
  rejection_events?: string | null;      // ✅ NEW
}

export interface ClinicalNoteResponse {
  status: string;
  message: string;
  note_id?: number;
  note?: ClinicalNote;
}

/**
 * Get all clinical notes for a patient
 */
export const getClinicalNotes = async (patientId: number): Promise<ClinicalNotesResponse> => {
  return apiClient.get<ClinicalNotesResponse>(`/doctors/clinical-notes/${patientId}`);
};

/**
 * Create a new clinical note
 */
export const createClinicalNote = async (data: CreateClinicalNoteRequest): Promise<ClinicalNoteResponse> => {
  return apiClient.post<ClinicalNoteResponse>('/doctors/clinical-notes', data);
};

/**
 * Update an existing clinical note
 */
export const updateClinicalNote = async (noteId: number, data: UpdateClinicalNoteRequest): Promise<ClinicalNoteResponse> => {
  return apiClient.put<ClinicalNoteResponse>(`/doctors/clinical-notes/${noteId}`, data);
};

/**
 * Delete a clinical note
 */
export const deleteClinicalNote = async (noteId: number): Promise<ClinicalNoteResponse> => {
  return apiClient.delete<ClinicalNoteResponse>(`/doctors/clinical-notes/${noteId}`);
};

export const clinicalNotesApi = {
  getClinicalNotes,
  createClinicalNote,
  updateClinicalNote,
  deleteClinicalNote,
};